export default {
      id: "block-usage",
      viewBox: "0 0 35 38",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#block",
      toString: function () {
        return this.url;
      }
    }